/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetSuggestionsRequest} from '@cash-web/protos/squareup/cash/kgoose/api/v3/cash/cash_suggestions.pb'
import {GetSuggestionsResponse} from '@cash-web/protos/squareup/cash/kgoose/api/v3/cash/cash_suggestions.pb'


export const getSuggestions = (request: GetSuggestionsRequest, options?: CashRequestOptions) => post<GetSuggestionsRequest, GetSuggestionsResponse>("/cash-app/goose-cash/v3/get-suggestions", request, {...options, rejectOnError: true })